import(/* webpackMode: "eager", webpackExports: ["default"] */ "/code/src/_layout/pageWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/code/src/core/pagetemplates/custom/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/code/src/core/pagetemplates/newsDetails/index.js");
